import React from 'react'
import PropTypes from 'prop-types'

import { GlgSimpleCheckbox } from 'Shared/components'

import LeaguesTypeIcon from '../common/LeaguesTypeIcon'
import LeagueRoundsTooltipChip from './LeagueRoundsTooltipChip'

const LeaguesBrowserItem = ({item, onCheckChanged, isSelected}) => {
  return (
    <div
      key={item.id}
      className='cls-lb-item-container'
      onClick={() => onCheckChanged(item.id)}
      >
      <GlgSimpleCheckbox
        checked={isSelected}
        className='cls-lb-item-checkbox'
      />
      <label
        className={isSelected ?
          'cls-lb-item-label-selected' :
          'cls-lb-item-label'}
      >
        {item.name}
      </label>
      <LeagueRoundsTooltipChip league={item}/>
      <LeaguesTypeIcon leagueType={item.product} compact/>
    </div>
  )
}

LeaguesBrowserItem.propTypes = {
  item: PropTypes.object.isRequired,
  onCheckChanged: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
}

export default LeaguesBrowserItem
